export default __webpack_public_path__ + "static/media/1.9ea584c8.png";